import ListView from './ListView.vue';

export default { ListView };